export const ManagementStrategy = {
  ACTIVE: 1,
  PASSIVE: 2
}

export const FilterOptions = {
  assetClasses: ['Equity', 'Fixed Income', 'Multi-Asset', 'Commodity', 'Cryptocurrencies', 'Currencies', 'Volatility'],
  zones: [
    'Canada',
    'US',
    'North America',
    'Europe',
    'Asia',
    'Asia Pacific',
    'Australia',
    'Brazil',
    'China',
    'Emerging markets',
    'Emerging Markets Asia',
    'Hong Kong',
    'India',
    'Japan',
    'Latin America',
    'Mexico',
    'No restriction',
    'Other',
    'South Korea',
    'UK',
    'World'
  ],
  currencies: ['USD', 'CAD'],
  themes: [
    'Health & Wellness',
    'Disruptive Technology',
    'Global Infrastructure',
    '3D Printing',
    '5G',
    'Agribusiness',
    'Alternative Energy',
    'Artificial Intelligence & Big Data',
    'At Home',
    'Battery Value-Chain',
    'BioTech & Genomics',
    'Blockchain',
    'Blue Economy',
    'Branding and Luxury',
    'Cannabis & Psychedelics',
    'China Consumer Growth',
    'China Digitalization',
    'China Disruptive Technology',
    'China Life Sciences',
    'China New Economy',
    'Circular Economy',
    'Climate Change',
    'Cloud Computing',
    'Cryptocurrency',
    'Cybersecurity',
    'Digital Infrastructure & Connectivity',
    'eCommerce',
    'Emerging Markets Awakening',
    'Emerging Markets Consumer Growth',
    'Emerging Markets Digitalization',
    'Emerging Markets Infrastructure',
    'FinTech',
    'Future Mobility',
    'Gender Equality',
    'Gig Economy',
    'Green Building',
    'Green Projects',
    'Healthcare Technology & Innovation',
    'Human Capital',
    'Hydrogen Economy',
    'Inclusion & Diversity',
    'Life Sciences',
    'Metaverse',
    'Millennials',
    'Multiple Trends',
    'Natural Resources',
    'Net Zero 2050',
    'New Consumers & Focus',
    'Next Generation Internet',
    'North America Energy Infrastructure',
    'Nuclear Energy',
    'Pet Care',
    'Robotics & Automation',
    'Silver Economy',
    'Smart City',
    'Solar Energy',
    'Space & Deep Sea',
    'Strategic Metals',
    'Sustainable Food',
    'Sustainable Resources Management',
    'Timber & Forestry',
    "Tomorrow's Treatments",
    'Travel Technology & Services',
    'Video Games & iGaming',
    'Waste Management',
    'Water',
    'Wind Energy'
  ],
  isEsg: [true, false],
  managementStrategy: [ManagementStrategy.ACTIVE, ManagementStrategy.PASSIVE],
  strategies: ['Long only', 'Leveraged', 'Inverse', 'Option Strategies', 'Other'],
  coreSectors: [
    'Aerospace & Defense',
    'Agricultural & Farm Machinery',
    'Agricultural Products',
    'Air Freight & Logistics',
    'Airlines',
    'Asset Management & Custody Banks',
    'Automobiles & Components',
    'Banks',
    'Biotechnology',
    'Capital Markets',
    'Closed End Investments',
    'Coal & Consumable Fuels',
    'Construction and Materials',
    'Consumer Discretionary',
    'Consumer Staples',
    'Copper Miners',
    'Energy',
    'Fertilizers & Agricultural Chemicals',
    'Financial Services',
    'Financials',
    'Food & Beverage',
    'Gas Exploration & Production',
    'Gold Miners',
    'Health Care',
    'Health Care Equipment',
    'Health Care Services',
    'Home Construction',
    'Industrial REITs',
    'Industrials',
    'Information Technology',
    'Infrastructure REITs',
    'Insurance',
    'Internet Retail',
    'Marine',
    'Marine Ports & Services',
    'Marine Transportation',
    'Materials',
    'Media',
    'Medical Equipment',
    'Metals Miners',
    'Mortgage REITs',
    'No restriction',
    'Oil & Gas Equipment & Services',
    'Oil & Gas Exploration & Production',
    'Oil and gas',
    'Oil Equipment and Services',
    'Oil Refining and Marketing',
    'Pharmaceuticals',
    'Precious Metals Miners',
    'Real Estate',
    'Real Estate Operating Companies',
    'Regional Banks',
    'REIT',
    'Residential REITs',
    'Retail',
    'Semiconductors',
    'Silver Miners',
    'Software',
    'Software & Services',
    'Steel',
    'Storage Facilities',
    'Telecommunications',
    'Transportation',
    'Travel & Leisure',
    'Utilities'
  ],
  sectors: [
    'Aerospace & Defense',
    'Agricultural & Farm Machinery',
    'Agricultural Products',
    'Air Freight & Logistics',
    'Airlines',
    'Asset Management & Custody Banks',
    'Automobiles & Components',
    'Banks',
    'Biotechnology',
    'Capital Markets',
    'Closed End Investments',
    'Coal & Consumable Fuels',
    'Construction and Materials',
    'Consumer Discretionary',
    'Consumer Staples',
    'Copper Miners',
    'Energy',
    'Fertilizers & Agricultural Chemicals',
    'Financial Services',
    'Financials',
    'Food & Beverage',
    'Gas Exploration & Production',
    'Gold Miners',
    'Health Care',
    'Health Care Equipment',
    'Health Care Services',
    'Home Construction',
    'Industrial REITs',
    'Industrials',
    'Information Technology',
    'Infrastructure REITs',
    'Insurance',
    'Internet Retail',
    'Marine',
    'Marine Ports & Services',
    'Marine Transportation',
    'Materials',
    'Media',
    'Medical Equipment',
    'Metals Miners',
    'Mortgage REITs',
    'No restriction',
    'Oil & Gas Equipment & Services',
    'Oil & Gas Exploration & Production',
    'Oil and gas',
    'Oil Equipment and Services',
    'Oil Refining and Marketing',
    'Pharmaceuticals',
    'Precious Metals Miners',
    'Real Estate',
    'Real Estate Operating Companies',
    'Regional Banks',
    'REIT',
    'Residential REITs',
    'Retail',
    'Semiconductors',
    'Silver Miners',
    'Software',
    'Software & Services',
    'Steel',
    'Storage Facilities',
    'Telecommunications',
    'Transportation',
    'Travel & Leisure',
    'Utilities'
  ],
  topProviders: ['iShares', 'First Trust', 'J.P. Morgan Asset Management', 'SPDR', 'Innovator', 'Fidelity', 'VanEck', 'Global X', 'Vanguard', 'WisdomTree'],
  providers: [
    '21Shares',
    '2ndVoteFund',
    '3EDGE Asset Management',
    '3Fourteen & SMI Advisory Services',
    '3iQ',
    '6 Meridian',
    'Abacus FCF Advisors',
    'abrdn',
    'Absolute Investment Advisers',
    'Academy Asset Management',
    'Accelerate Financial Technologies',
    'Acquirers Fund',
    'Acruence Capital',
    'Adaptiv',
    'Adaptive Investments',
    'Adasina Social Capital',
    'ADRH',
    'Advent',
    'Advisors Asset Management',
    'AdvisorShares',
    'Advocate Capital Management',
    'AGF',
    'Agility Shares',
    'AGOV ETF',
    'AIIQ ETF',
    'Akros',
    'Alexis Investment',
    'AllianceBernstein',
    'Allianz Investment Management LLC',
    'Allspring',
    'Alpha Architect',
    'Alpha Blue Capital Management',
    'Alpha Intelligent Strategies',
    'AlphaMark Advisors',
    'ALPS',
    'Alternative Access Funds',
    'Altrius Funds',
    'AltShares',
    'Amberwave',
    'American Beacon',
    'American Century Investments',
    'Amplify ETFs',
    'Angel Oak Capital Advisors',
    'Applied Finance',
    'APTUS ETFs',
    'Arch Indices',
    'Ark Investment',
    'Armada ETF Advisors',
    'Armor Index ETFs',
    'Arrow Capital',
    'ArrowShares',
    'Astoria Portfolio Advisors',
    'ASYMmetric ETFs',
    'Auspice Capital',
    'Avantis Investors',
    'AWARE Asset Management',
    'AXS Investments',
    'AZTLAN Equity Management',
    'Bahl & Gaynor',
    'Ballast Asset Management',
    'Barclays',
    'BattleShares',
    'Beacon Capital Management',
    'Belpointe Asset Management',
    'Beyond Investing',
    'Bitwise',
    'Blue Horizon Capital',
    'BMO',
    'BNY Mellon',
    'Bondbloxx Investment Management LLC',
    'Brandes',
    'Bridges Capital',
    'Bridgeway Capital Management',
    'Brinsmere',
    'Bristol Gate',
    'Brompton Group',
    'Brookmont Capital Management',
    'Brookstone Asset Management',
    'Brown Advisory',
    'Build Asset Management',
    'Cabana ETF',
    'Cabot ETF',
    'Calamos Investments',
    'Caldwell Investment',
    'Cambiar Investors',
    'Cambria',
    'Cannell & Spears LLC',
    'Capital Group',
    'Capital Insight Partners',
    'Capital Link',
    'Carbon Collective',
    'CastleArk Management',
    'Cavalier Investments',
    'CCB Principal Asset Management',
    'CCM Investment Group',
    'Change Finance',
    'CI',
    'CIBC',
    'Clear Shares',
    'ClearBridge',
    'Clockwise Capital',
    'Clough Capital',
    'Clouty',
    'CNIC Funds',
    'Coastal Compass Funds',
    'Cohen & Steers',
    'CoinShares',
    'Collaborative Fund Advisors',
    'Columbia Threadneedle Investments',
    'Community Capital Management',
    'Congress Asset Management',
    'Constrained Capital',
    'Convergence Investment Partners LLC',
    'ConvexityShares',
    'Corbett Road Capital Management',
    'CornerCap Investment Counsel',
    'Corton Capital',
    'CP ETFs',
    'Credit Suisse AM',
    'Crossingbridge',
    'CSOP',
    'Cullen Capital Management',
    'Cultivar Capital',
    'Curran Financial Partners',
    'DailyDelta',
    'Davis ETFs',
    'Day Hagan Asset Management',
    'Days Global Advisors',
    'Defiance ETFs',
    'DeltaShares',
    'Democracy Investments',
    'Desjardins Investments',
    'Deutsche Bank AG',
    'Diamond Hill Capital Management',
    'Dimensional',
    'Draco Evolution',
    'DriveWealth',
    'Dynamic Funds',
    'Dynamic Shares',
    'Eagle Capital Management',
    'Eaton Vance',
    'ecofin',
    'Elkhorn',
    'Elm Partners Management',
    'Emerald Group',
    'Emerge Canada Inc',
    'Emerge Capital Management',
    'EMG Advisors',
    'Emles Advisors',
    'EntrepreneurShares',
    'Envestnet Asset Management',
    'ETF Securities',
    'ETFMG',
    'Euclidean',
    'Even Herd',
    'Event Shares',
    'Eventide',
    'Evermore',
    'Evoke-Aris',
    'Evolve ETFs',
    'Exchange Traded Concepts',
    'Exponential ETFs',
    'F/m Investments',
    'Fairlead Strategies',
    'Faith Investor Services',
    'Federated Investment Management',
    'Fidelity',
    'Fire ETFs',
    'First Block Capital',
    'First Eagle Investments',
    'First Manhattan',
    'First Pacific Advisors',
    'First Trust',
    'FlexShares',
    'FolioBeyond',
    'Foothill Capital Management',
    'Foreside Management Services',
    'Formidable',
    'FormulaFolio Investments',
    'Forstrong Global Asset Management',
    'Fortuna',
    'Franklin Templeton',
    'Fred Alger Management',
    'Freedom Day Solutions',
    'Freedom ETFs',
    'Frontier Asset Management',
    'Fundstrat',
    'FundX',
    'Future Fund ETF',
    'Gabelli Funds',
    'Gadsen',
    'GammaRoad',
    'GCI Investors',
    'Genter Capital',
    'Genz ETF',
    'GGM Wealth Advisors',
    'Global Beta ETFs',
    'Global X',
    'GMO',
    'Goldman Sachs',
    'Goose Hollow Capital Management',
    'Gotham ETFs',
    'GraniteShares',
    'Grayscale',
    'Grizzle',
    'Guardian Capital',
    'Guggenheim',
    'Hamilton ETFs',
    'Harbor Capital',
    'Hartford Funds',
    'Harvest Global Investments Limited',
    'Harvest Portfolios Group',
    'Hashdex',
    'Hennessy Funds',
    'Highland Capital',
    'Hilton Capital Management',
    'Horizon Investments',
    'Horizon Kinetics LLC',
    'Horizons ETFs',
    'Hotchkis & Wiley Capital Management',
    'Howard Capital Management',
    'Hoya Capital',
    'Hull Tactical Funds',
    'Humankind',
    'Hypatia',
    'IA Clarington',
    'iClima ETFs',
    'IDX Advisors',
    'iM Global Partner',
    'iMGP Funds',
    'Impact Shares',
    'IndexIQ',
    'Indexperts',
    'Infrastructure capital advisors',
    'Infusive',
    'Inherent Wealth Fund',
    'Innovation Shares',
    'Innovative Portfolios',
    'Innovator',
    'Inspire ETFs',
    'Intech Investment Management',
    'Intelligent Alpha',
    'Ionic Capital Management',
    'iREIT',
    'IronHorse Capital Management',
    'iShares',
    'J.P. Morgan Asset Management',
    'Jacob Asset Management of New York',
    'Janus Henderson Investors',
    'Jensen Investment Management',
    'JLens',
    'John Hancock Investments',
    'Keating Investment Counselors',
    'Kelly ETFs',
    'Kings Barn',
    'KKM Financial',
    'Knights of Columbus',
    'Kovitz',
    'KraneShares',
    'Kurv Investment Management',
    'Langar Investment Management',
    'Lazard Asset Management',
    'LeaderShares ETFs',
    'Leatherback Asset Management',
    'Legg Mason',
    'Leverage Shares',
    'LifeGoal',
    'Little Harbor Advisor',
    'LocalShares',
    'Logan Capital Management Inc.',
    'LongPoint Asset Management',
    'LSV Asset Management',
    'Lyrical Asset Management',
    'Lysander Funds',
    'Mackenzie Investments',
    'Macquarie',
    'Madison Investments',
    'Main Management ETF Advisors',
    'Mairs & Power',
    'Manulife Investments',
    'mason capital Partners',
    'Matrix Asset Advisors',
    'Matthews Asia',
    'McCarthy & Cox',
    'Measured Risk Portfolios',
    'MERK Funds',
    'Merlyn.AI',
    'Metaurus',
    'MFS',
    'Middlefield',
    'Militia Investments',
    'Miller Value Funds',
    'MKAM ETF LLC',
    'Mohr Funds',
    'Monarch Fund',
    'Morgan Creek',
    'Morgan Dempsey Capital Management',
    'Morgan Stanley',
    'Motley Fool Asset Management',
    'MRBL Management',
    'Mulvihill',
    'MUSQ',
    'National Bank Investments',
    'Nationwide',
    'Natixis',
    'NCM Asset Management',
    'Ned Davis Research',
    'NEOS Investment Management',
    'NestYield',
    'NETLease',
    'Neuberger Berman',
    'New Age Alpha',
    'New York Life Investment',
    'Newday Impact ETFs',
    'NextGen EMP',
    'NextGen ETFs',
    'Nicholas Wealth Management',
    'NightShares',
    'Nightview Capital',
    'Ninepoint Partners',
    'Noble-Impact Capital',
    'North Shore',
    'North Square Investments',
    'Nottingham Company',
    "O'Shares",
    'Oakmark Funds',
    'Obra Funds',
    'Ocean Park Asset Management',
    'Octane',
    'OneAscent Investments',
    'ONEFUND',
    'Optimize Advisors',
    'Optimize Financial',
    'OT Advisors',
    'Otter Creek',
    'Overlay Shares',
    'PACER ETFs',
    'Pacific Asset Management',
    'Pacific Global ETFs',
    'Palmer Square',
    'Panagram Structured Asset Management',
    'Parabla LLC',
    'Parnassus Investments',
    'PeakShares',
    'Peerless etfs',
    'PEO AlphaQuest',
    'Perth Mint',
    'PGIM',
    'Picton Mahoney',
    'PIMCO',
    'Pinnacle Dynamic Funds',
    'PlanRock Investment Management',
    'PMV Capital',
    'Point Bridge Capital',
    'Polen Capital',
    'Praxis',
    'Precidian',
    'Premise Capital',
    'Principal Global Investors',
    'ProcureAM',
    'ProShares',
    'PT Asset Management',
    'PureFunds',
    'Purpose Investments',
    'Putnam',
    'Q3 Asset Management',
    'Qraft AI ETFs',
    'Quadravest',
    'Quantify Funds',
    'QuantX Funds',
    'Questrade',
    'R1VER Asset Management',
    'R3',
    'Rafferty Asset Management LLC',
    'Rareview Capital',
    'Rayliant Asset Management',
    'RBC Global Asset Management',
    'Reality Shares ETFs',
    'Reflection Asset Management',
    'Regan Capital',
    'Regents Park Funds',
    'Relative Sentiment',
    'Renaissance Capital',
    'Return Stacked ETFs',
    'REX Shares',
    'Ridgeline Research',
    'Robinson Capital',
    'ROBO Global ETFs',
    'RockCreek',
    'Rockefeller Asset Management',
    'Roundhill Investments',
    'Royal Canadian Mint',
    'Ruff ETF',
    'Running Oak Capital',
    'Russell Investment Management',
    'Saba Capital',
    'Sage',
    'Salt Financial',
    'SanJac Alpha LP',
    'Sarmaya Partners',
    'Schwab ETFs',
    'Scotia Bank',
    'Segall Bryant & Hamill Asset Management',
    'SEI',
    'SEK',
    'SerenityShares',
    'Simplify',
    'SirenETFs',
    'Smart Money Group',
    'SmartBe Wealth',
    'SmartETFs',
    'SoFi',
    'SonicShares',
    'Soundwatch Capital',
    "Sovereign's Capital",
    'Sparkline Capital',
    'SPDR',
    'Spear ETFs',
    'SPFunds',
    'Split Rock Trading',
    'Sprott ETFs',
    'SRH Funds',
    'Stance Capital',
    'Starlight Capital',
    'Sterling Capital Active ETF',
    'STF Management',
    'StockSnips',
    'Stone Ridge',
    'Strategas Asset Management',
    'Strategy Shares',
    'strategyshares',
    'Strive Asset Management',
    'Subversive Capital',
    'Summit Global Investments',
    'Summit Water',
    'Swan Capital Management',
    'SWP Invest',
    'Syntax',
    'T. Rowe Price',
    'TappAlpha',
    'TCW',
    'TD Asset Management',
    'Tema',
    'Teucrium',
    'Texas Capital',
    'The Burney Company',
    'The Leuthold Group',
    'The RBB Fund, Inc',
    'Themes Management Company',
    'THOR Financial Technologies',
    'Thornburg',
    'Thrivent Asset Management',
    'Timothy Plan',
    'Toroso Asset Management',
    'Tortoise Capital',
    'Touchstone Investments',
    'Traders A.I.',
    'Trajan Wealth',
    'Tralucent Asset Management',
    'Tremblant Advisors',
    'TriLine Index Solutions',
    'Trimtabs Asset Management',
    'TrueShares',
    'Tuttle Capital Management',
    'Tweedy, Browne',
    'Twin Oak ETF Company',
    'U.S. Global ETFs',
    'UBS',
    'Ultra Blue Capital',
    'Uncommon Investment Advisors',
    'Unity Wealth Partners',
    'Universal Value Advisors',
    'unlimited',
    'UP Fintech Asset Management',
    'Upholdings Group LLC',
    'URNM ETF',
    'USAA',
    'USCF',
    'USCF Investment',
    'Valkyrie',
    'VanEck',
    'Vanguard',
    'VectorShares',
    'VegTech',
    'VERIDIEN GLOBAL INVESTORS',
    'Vert Asset Management',
    'Vesper Capital Management',
    'Vest',
    'VictoryShares',
    'Vident',
    'Viridi Funds',
    'VIRTUS Investment Partners',
    'VistaShares',
    'Volatility Shares',
    'Volt Funds',
    'Vshares',
    'Wahed',
    'WBI Shares',
    'Wealthtrust',
    'WEBs',
    'Westwood',
    'WHITEWOLF',
    'Whitford',
    'Wilshire Phoenix Funds LLC',
    'WisdomTree',
    'X-Square Capital',
    'Xtrackers by DWS',
    'YieldMax ETFs',
    'YieldShares',
    'Zacks ETFs'
  ]
}
